import { ref } from 'vue'

import { dateRangeForApi, formatDateRangeLabel } from '@/helpers/reportDateRanges'

export function useReportDateRange(defaultPreset) {
  const selectedDateRange = ref(defaultPreset)
  const selectedDateRangeLabel = ref('')
  const customDateRange = ref(null)

  const setDateRange = value => {
    if (typeof value === 'string') {
      selectedDateRange.value = value
      customDateRange.value = null
      selectedDateRangeLabel.value = ''
    } else if (
      value &&
      value.start !== null &&
      value.start !== undefined &&
      value.end !== null &&
      value.end !== undefined
    ) {
      customDateRange.value = value
      selectedDateRangeLabel.value = formatDateRangeLabel(value.start, value.end)
      selectedDateRange.value = ''
    }
  }

  const apiDateRange = () => dateRangeForApi(selectedDateRange.value, customDateRange.value)

  return { selectedDateRange, selectedDateRangeLabel, customDateRange, setDateRange, apiDateRange }
}
